import { Instance } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import { Vector3 } from 'three'
import { SolarPanelGeometry } from './SolarPanelGeometry'
import { useCellCountAndOffset } from './useCellCountAndOffset'
import { useDimensions } from './useDimensions'

export const SolarPanels = () => {
  const { panelDimensions, solarCellThickness } = useDimensions()

  const {
    countLength,
    countWidth,
    length,
    offsetLength,
    offsetWidth,
    startOffsetLength,
    startOffsetWidth,
    width,
  } = useCellCountAndOffset()

  const generalOffset = [
    panelDimensions / 2.0,
    panelDimensions / 2.0,
    -solarCellThickness / 2,
  ]

  const panelPositions = []
  for (let indexX = 0; indexX < countWidth; indexX++) {
    for (let indexY = 0; indexY < countLength; indexY++) {
      const x = indexX * offsetWidth + generalOffset[0]
      const y = indexY * offsetLength + generalOffset[1]

      panelPositions.push([x, y, generalOffset[2]])
    }
  }

  let position = [startOffsetWidth, startOffsetLength, -generalOffset[2]]
  if (countWidth === 1 || countLength === 1) {
    position = [
      countWidth === 1 ? (width - panelDimensions) / 2.0 : position[0],
      countLength === 1 ? (length - panelDimensions) / 2.0 : position[1],
      -generalOffset[2],
    ]
  }

  // VFO: Removed instances for AR-Test
  // return
  // <Instances
  //   range={panelPositions.length}
  //   position={position as any}
  //   castShadow
  // >
  //   <SolarPanelGeometry />

  //   {panelPositions.map((data, index) => (
  //     <SolarPanelInstance position={data as any} key={index} />
  //   ))}
  // </Instances>

  return (
    <group position={position as any}>
      {panelPositions.map((data, index) => {
        return <SolarPanelGeometry key={index} position={data} />
      })}
    </group>
  )
}

const SolarPanelInstance = ({ position }: { position: Vector3 }) => {
  const ref = useRef()
  const { length, width } = useDimensions()
  const rotation = [0, 0, length < width ? Math.PI / 2 : 0]

  useFrame(() => {
    // @ts-ignore
    ref?.current?.position.set(...position)
    // @ts-ignore
    ref?.current?.rotation.set(...rotation)
  })

  return <Instance ref={ref} />
}
